var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavourite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8877 20.8767C42.2827 19.6803 41.0475 18.9346 39.707 18.9565C38.3665 18.9785 37.1563 19.7642 36.5908 20.9798L31.7846 31.3115C31.1351 32.6314 30.1658 33.7781 28.9582 34.6477C27.7422 35.5234 26.323 36.0905 24.8266 36.2955L24.8074 36.2981L13.5411 37.9045C12.2189 38.093 11.1193 39.0175 10.7065 40.2877C10.2937 41.5579 10.6398 42.9523 11.5987 43.8821L19.7208 51.7581L19.7208 51.7581L19.7299 51.7668C20.8153 52.8118 21.6253 54.0984 22.0939 55.5145C22.5616 56.928 22.6762 58.431 22.4286 59.8962C22.4282 59.8988 22.4278 59.9014 22.4273 59.904L20.4913 70.976C20.2623 72.2851 20.7946 73.6109 21.8652 74.3984C22.9358 75.1858 24.36 75.2989 25.5415 74.6904L35.6026 69.5087L35.6345 69.4921C36.9676 68.7881 38.4583 68.4186 39.9739 68.4186C41.4895 68.4186 42.98 68.7881 44.3132 69.4921L44.3516 69.5121L54.4651 74.6938C55.6466 75.2992 57.069 75.1839 58.1377 74.3962C59.2064 73.6084 59.7374 72.2839 59.5087 70.9761L57.5699 59.8871L57.5694 59.8845C57.3126 58.422 57.419 56.9196 57.8803 55.5056C58.3412 54.0926 59.1437 52.8075 60.2219 51.7629C60.2228 51.762 60.2238 51.7611 60.2247 51.7602L68.3934 43.8899C69.3567 42.9618 69.7067 41.5659 69.2954 40.2931C68.884 39.0203 67.7832 38.0933 66.459 37.9045L55.1927 36.2981L55.1734 36.2954C53.6677 36.0893 52.239 35.5206 51.013 34.6425C49.7873 33.7645 48.8026 32.605 48.1421 31.2686L48.1278 31.2401L42.8877 20.8767Z",
    stroke: "#404041",
    strokeWidth: 7,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2969 11.2285V4.21094",
    stroke: "#404041",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.475 15.4384L26.668 8.4209",
    stroke: "#404041",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0515 22.4558L15.4375 16.8418",
    stroke: "#404041",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7383 22.4558L61.7558 16.8418",
    stroke: "#404041",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7188 15.4384L50.5258 8.4209",
    stroke: "#404041",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.c796dd5f8da08806a49670f8397f8fd0.svg";
export { ForwardRef as ReactComponent };